<div class="ph-upload-photo">
  <div class="ph-upload-photo__container">
    <div class="ph-upload-photo__image-overlay"></div>
    <div class="ph-upload-photo__image-remove" (click)="emitClose($event)">
      <img src="assets/img/icons/remove-photo.svg" [alt]="'PROJECT.remove_photo' | translate" />
    </div>
    <div class="ph-upload-photo__image-change">
      {{ 'PROJECT.change_image' | translate }}
    </div>
    <img [src]="currentUpload" />
  </div>
</div>
